<button type="button" class="help-button" aria-hidden="true" tabindex="-1" [attr.aria-label]="'arialabel.toggle.help' | translate"  (click)="toggleDialog()" (keydown)="onKeyDown($event)"><i class="icon-help-circle"></i></button>
<div #infowindow [id]="id" role="dialog" aria-hidden="true" [class.hidden]="!showDialog" [style.width]="width > 0? width + 'px' : null" [class.overlay]="showAsOverlay" (window:resize)="setWidth()" [style.margin-top]="topMargin + 'px'">
  @if (showDialog) {
    <span class="arrow" aria-hidden="true" [style.margin-top]="(topMargin * -1) + 'px' "></span>
  }
  @if (!showAsOverlay) {
    <p id="{{'dialog' + id + 'Head'}}" class="headline" [innerHTML]="advisor + '.' + formModel.id + '_info_headline' + headlinePostfix | translate: {fallback: headlineFallback}"></p>
  }
  @if (imageData) {
    <div class="image-wrapper" (click)="toggleOverlay($event)" [style.paddingTop]="showAsOverlay? topPadding + 'px' : '0px'" [class.zoom]="showZoomPrimary || showZoomSecondary" [class.has-zoom]="extraImage">
      <div class="grid-x grid-margin-x">
        <div class="cell small-12" [class.medium-9]="showAsOverlay && extraImage && !showZoomPrimary" [class.hidden]="showZoomSecondary">
          @if (showAsOverlay) {
            <h3 (click)="zoomPrimary()">@if (showZoomPrimary) {
              <button tabindex="-1"><i class="icon-arrow-left"></i></button>
              }<span [innerHTML]="advisor + '.infooverlay.headline.left' | translate"></span></h3>
            }
            @if (!useCanvas) {
              <img [src]="imageData.image" alt="" tabindex="-1" (keydown.enter)="showAsOverlay = true">
            }
            <div class="canvas-image" (click)="zoomPrimary()">
              <canvas #canvasElement [class.hidden]="!useCanvas" style="max-width: 100%; height: auto;" tabindex="-1" (keydown.enter)="showAsOverlay = true" ></canvas>
            </div>
            @if (showAsOverlay) {
              <p [innerHTML]="advisor + '.' + formModel.id + '_info_headline' + headlinePostfix | translate: {fallback: headlineFallback}"></p>
            }
            @if (showAsOverlay) {
              <p [innerHTML]="advisor + '.' + formModel.id + '_info_text' + fieldNamePostfix | translate"></p>
            }
          </div>
          @if (showAsOverlay && extraImage) {
            <div class="cell small-12" [class.medium-3]="!showZoomSecondary" [class.hidden]="showZoomPrimary">
              <h3 (click)="zoomSecondary()">@if (showZoomSecondary) {
                <i class="icon-arrow-left"></i>
                }<span [innerHTML]="advisor + '.infooverlay.headline.right' | translate"></span></h3>
                <app-canvas-image aria-hidden="true" [image]="extraImage.path" [marker]="extraImage.marker" [hasOverlay]="false" (click)="zoomSecondary()"></app-canvas-image>
              </div>
            }
            @if (showAsOverlay) {
              <button type="button" class="close" tabindex="-1" (click)="toggleOverlay($event)">
                <i class="close icon-x-circle"></i>
              </button>
            }
          </div>
        </div>
      }
      <p id="{{'dialog' + id + 'Desc'}}" class="description" [innerHTML]="advisor + '.' + formModel.id + '_info_text' + fieldNamePostfix | translate"></p>
      @if (!showAsOverlay) {
        <button type="button" tabindex="-1" class="close" (click)="showDialog = !showDialog" (keydown)="onKeyDown($event)"> <i class="icon-x-circle"></i></button>
      }
    </div>
